<template>
<div>
    <div class="concierce_uselist">
        <div class="inner">
            <div class="title">
                사용내역
                <div class="select_box" >
                    <select class="btn_select" @change="selectBoxChange($event)">
                        <option value="A">전체</option>
                        <option value="G">선물</option>
                        <option value="M">사용</option>
                    </select>
                </div>
            </div>

            <div class="uselist_box">
                <template v-if="couponsDetails.length > 0" >
                    <ul>
                        <template v-for="couponDetail in couponsDetails" >
                            <li>
                                <template v-if="couponDetail.mobile_number=='MYSELF'" >
                                    <div class="use_flag use">사용</div>
                                    <div class="use_date">
                                        <p>{{couponDetail.used_date}}</p>
                                        <span>{{couponDetail.store_name}}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="use_flag_box">
                                        <div class="use_flag gift">선물</div>
                                        <p class="use_flag_user">
                                            받으신 분
                                            <span>( {{maskingPhoneNumber(couponDetail.mobile_number)}} )</span>
                                        </p>
                                    </div>
                                    <div class="use_date">
                                        <p>{{couponDetail.used_date}}</p>
                                        <span v-if="couponDetail.use_yn=='Y'">{{couponDetail.store_name}}</span>
                                    </div>
                                    <template v-if="couponDetail.use_yn=='Y'">
                                        <div class="use_state complete">사용완료</div>
                                    </template>
                                    <template v-else>
                                        <div class="use_state yet">사용전</div>
                                        <!-- <button type="button" v-if="!isexpired" class="coupon_withdraw" data-layer="orderCancel-layer" 
                                            @click="couponRetrievePopup(true, couponDetail)" >
                                            <span>바우처 회수</span>
                                        </button> -->
                                    </template>
                                </template>
                            </li>
                        </template>
                    </ul>
                </template>
                <div v-else class="no_data">
                    사용하신 내역이 없습니다.
                </div>

                <button type="button" class="btn_more" @click="btnMoreClickEvent">
                    <span>내역 더 보기</span>
                </button>
            </div>
        </div>
    </div>

<!-- S : 바우처 회수 팝업 -->
    <div id="orderCancel-layer" class="layer_section type-narrow-a" :class="{showing:popupFlag}" >
		<div class="layer_section-container">
			<div class="layer-content">
				<div class="pop-orderCancel-area">
					<p class="tit">
						선물하신 파이토 바우처를 회수하시겠습니까?<br>
						(이미 사용하신 경우 회수 되지 않습니다.)
					</p>
				</div>
			</div>
			<div class="align-box size-auto">
				<button type="button" class="btn-modal_confirm" @click="couponRetrievePopup(false)">취소</button>
				<button type="button" class="btn-modal_close v2" @click="couponRetrieve">바우처 회수</button>
			</div>
		</div>
	</div>
	<!-- E : 바우처 회수 팝업 -->
</div>
</template>

<script>

export default {
    name: 'uselist',
    props:{
        couponsDetails: Array,
        isexpired: Boolean,
    },
    data () {
        return {
            popupFlag: false,
            coupon: Object
        }
    },
    methods: {
        checkNull : function (str){
            if(typeof str == "undefined" || str == null || str == ""){
                return true;
            }
            else{
                return false;
            }
        },
        maskingPhoneNumber : function(str){
            let originStr = str;
            let phoneStr;
            let maskingStr;
            if(this.checkNull(originStr) == true){
                return originStr;
            }
            if (originStr.toString().split('-').length != 3)
            { // 1) -가 없는 경우
                phoneStr = originStr.length < 11 ? originStr.match(/\d{10}/gi) : originStr.match(/\d{11}/gi);
                if(this.checkNull(phoneStr) == true){
                    return originStr;
                }
                if(originStr.length < 11)
                { // 1.1) 0110000000
                    maskingStr = originStr.toString().replace(phoneStr, phoneStr.toString().replace(/(\d{3})(\d{3})(\d{4})/gi,'$1***$3'));
                }
                else
                { // 1.2) 01000000000
                    maskingStr = originStr.toString().replace(phoneStr, phoneStr.toString().replace(/(\d{3})(\d{4})(\d{4})/gi,'$1****$3'));
                }
            }else{ // 2) -가 있는 경우
                phoneStr = originStr.match(/\d{2,3}-\d{3,4}-\d{4}/gi);
                if(this.checkNull(phoneStr) == true){
                    return originStr;
                }
                if(/-[0-9]{3}-/.test(phoneStr))
                { // 2.1) 00-000-0000
                    maskingStr = originStr.toString().replace(phoneStr, phoneStr.toString().replace(/-[0-9]{3}-/g, "-***-"));
                } else if(/-[0-9]{4}-/.test(phoneStr))
                { // 2.2) 00-0000-0000
                    maskingStr = originStr.toString().replace(phoneStr, phoneStr.toString().replace(/-[0-9]{4}-/g, "-****-"));
                }
            }
            
            return maskingStr;
        },
        selectBoxChange: function(event){
            this.$emit('updateListMode', event.target.value);
        },
        btnMoreClickEvent: function(){
            this.$emit('updateListSize');
        },
        couponRetrievePopup: function(flag, cDetail=null){
            this.popupFlag=flag;
            this.$emit('scrollLockWhenPopupOpen', flag);
            if(cDetail){
                this.coupon=cDetail
            }
        },
        couponRetrieve: function(){
            this.popupFlag=false;
            this.$emit('setcouponRetrieve', this.coupon);
            this.coupon=null;
        },
    },
    mounted() {
        this.coupon=null;
    },
}
</script>


// WEBPACK FOOTER //
// src/views/concierge/component/uselist.vue